import { createSelector } from 'reselect';

export const downloadVideoSelector = createSelector(
  (state) => state.custom.downloadVideo,
  (dv) => dv
);
